module.exports = __webpack_public_path__ + "img/partnership-selection-top.83a8a301.jpg";